function NoMatch() {
  return (
    <div
      className="mt-5 flex-column text-white d-flex justify-content-center align-items-center"
      style={{ height: "60.5" + "vh" }}
    >
      <h1>No match</h1>
      <p>URL NOT FOUND</p>
    </div>
  );
}
export default NoMatch;
